<template>
  <div class="menu" :class="modifiers">
    <BaseMenuItem
      v-for="(item, i) in items"
      :key="`menu_item_${i}`"
      v-bind="item"
      class="menu__item"
      @click="item.action ? item.action() : null"
    />
  </div>
</template>

<script>
import BaseMenuItem from '@/components/BaseMenuItem.vue';

export default {
  name: 'BaseMenu',
  components: {
    BaseMenuItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    modifiers() {
      return {
        [`menu_items_${this.items.length}`]: true,
      };
    },
  },
};
</script>

<style lang="stylus">
.menu
  width 100%
  height 100%

  &__item

    ~/_items_2 &
      float left
      width calc(50% - 0.25em)
      height 100%
      &:nth-child(2n)
        margin-left 0.5em

    ~/_items_3 &
      float left
      width calc(33.3333333333% - 0.2em)
      height 100%
      &:nth-child(2)
        margin-left 0.3em
        margin-right @margin-left

    ~/_items_4 &
      float right
      width calc(50% - 0.15em)
      height calc(70% - 0.15em)
      &:nth-child(2n)
        margin-right 0.3em
      &:not(:nth-child(-n+2))
        margin-top 0.3em
        height calc(30% - 0.15em)

    ~/_items_5 &
      float left
      width calc(33.3333333333% - 0.2em)
      height calc(50% - 0.15em)
      &:nth-child(1)
      &:nth-child(2)
      &:nth-child(4)
        margin-right 0.3em
      &:nth-child(4)
        width calc(66.666666666% - 0.1em)
      &:nth-child(4)
      &:nth-child(5)
        margin-top 0.3em

    ~/_items_6 &
      width calc(33.3333333333% - 0.2em)
      float right
      margin-left 0.3em
      &:nth-child(1)
      &:nth-child(4)
        height calc(50% - 0.15em)
        float left
        margin-left 0
      &:nth-child(2)
      &:nth-child(3)
        height calc(70% - 0.15em)
      &:nth-child(5)
      &:nth-child(6)
        height calc(30% - 0.15em)
        margin-top 0.3em
      &:nth-child(4)
        margin-top 0.3em
</style>
